import {
    AnyObject,
    BaseQueryResponse,
    SearchQueryResponse,
} from '@common/types/queryState';

export const isEmpty = <T>(value: T): boolean => {
    return (
        value === undefined ||
        value === null ||
        (typeof value === 'string' && value.trim().length === 0) ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && Object.keys(value).length === 0)
    );
};

export const isNotEmpty = <T>(
    value: T | null | undefined,
): value is NonNullable<T> => {
    return !isEmpty(value);
};

export const hasValues = <T extends object>(entry: T): boolean =>
    Object.values(entry).some((value) => !!value);

export const hasValuesOrFalsy = <T extends object>(entry: T): boolean =>
    Object.values(entry).some((value) => value !== null && value !== undefined);

export const isNullOrUndefined = (value: unknown): boolean =>
    value === null || value === undefined;

export const isObject = (value: unknown): value is AnyObject => {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        return false;
    }

    const proto = Object.getPrototypeOf(value);
    return proto === null || proto === Object.prototype;
};

export const isSearchQueryResponse = <T>(
    response: BaseQueryResponse<T>,
): response is SearchQueryResponse<T> => {
    return (
        (response as SearchQueryResponse<T>).numFound !== undefined &&
        Array.isArray((response as SearchQueryResponse<T>).results)
    );
};
